export default __webpack_public_path__ + "static/media/arcanemarauder.b785c777.png";